import { render, staticRenderFns } from "./AppGrid.vue?vue&type=template&id=f2483ca2&scoped=true"
import script from "./AppGrid.vue?vue&type=script&lang=js"
export * from "./AppGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2483ca2",
  null
  
)

export default component.exports